// src/components/views/DistrictView.js
import React, { useMemo, useState } from 'react';
import DistrictStats from '../DistrictStats';
import ProblemTypesChart from '../charts/ProblemTypesChart';
import DistrictProblems from '../DistrictProblems';
import SchoolsTable from '../SchoolsTable';
import SurveyModal from '../SurveyModal';
import { hasTimelinessProblems } from '../../utils/calculations';

const DistrictView = ({ allData, filters, updateFilters, onBack, onLoadSurveyData }) => {
  const { district } = filters;
  const districtData = filterDataByDistrict(district, allData);
  const districtSurveyData = allData.survey.districts[district];
  const [showSurveyModal, setShowSurveyModal] = useState(false);
  const [surveyLoading, setSurveyLoading] = useState(false);

  const districtSchoolIds = useMemo(() => {
    return districtData.dates.map(school => school.Код.toString());
  }, [districtData.dates]);

  const handleShowSurvey = async () => {
    setSurveyLoading(true);
    await onLoadSurveyData('district', district, district, districtSchoolIds);
    setSurveyLoading(false);
    setShowSurveyModal(true);
  };

  if (districtData.dates.length === 0) {
    return (
      <div id="district-view" className="view">
        <button className="back-button" onClick={onBack}>← Назад</button>
        <div className="level-indicator">Район</div>
        <h2 className="view-title">{district}</h2>
        <div className="no-data">Нет данных для выбранного района</div>
      </div>
    );
  }

  return (
    <div id="district-view" className="view">
      <button className="back-button" onClick={onBack}>← Назад</button>
      <div className="level-indicator">Район</div>
      <h2 className="view-title">{district}</h2>
      
      <DistrictStats district={district} allData={allData} filters={filters} />
      
 

      {showSurveyModal && (
        <SurveyModal
          surveyData={districtSurveyData}
          entityName={district}
          level="district"
          onClose={() => setShowSurveyModal(false)}
        />
      )}
      
      <div className="card wide-card">
        <h3>Типы недочетов в районе</h3>
        <ProblemTypesChart districtData={districtData} filters={filters} />
      </div>

      <DistrictProblems districtData={districtData} filters={filters} />

      <div className="card wide-card">
        <h3>ОУ с недочетами в районе</h3>
        <SchoolsTable 
          district={district} 
          districtData={districtData} 
          updateFilters={updateFilters}
          filters={filters}
        />
      </div>
    </div>
  );
};

const filterDataByDistrict = (district, data) => {
  const filteredTimeliness = data.timeliness.filter(item => item.Район === district);
  
  return {
    dates: data.dates.filter(item => item.РайонНаименование === district),
    errors: data.errors.filter(item => item.Район === district),
    publication: data.publication.filter(item => item.Район === district),
    compliance: data.compliance.filter(item => item.Район === district),
    timeliness: filteredTimeliness
  };
};

export default DistrictView;